import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class JobService {
  private url = GlobalService.serverURL + 'recruiter/manage_job_view/';
private manageEmployeeUnavaibilityUrl = GlobalService.serverURL + 'recruiter/manage_employee_availability/'
  constructor(private http: HttpClient) { }
  addUnavailablity(data){
    return this.http.post(this.manageEmployeeUnavaibilityUrl + 'add_unavailability', data, { headers })
  }
  createJob(data) {
    return this.http.post(this.url + 'create_job', data, { headers });
  }
  copyJob(data) {
    return this.http.post(this.url + 'copy_job', data, { headers });
  }
  dupJob(data) {
    return this.http.post(this.url + 'duplicate_job', data, { headers });
  }
  editJob(data) {
    return this.http.post(this.url + 'edit_job', data, { headers }); 
  }
  // API cALLED IN THE CALENDAR
  getJobData(data) {
    return this.http.post(this.url + 'get_data', data, { headers });
  }
  getOnlyJobData(data) {
    return this.http.post(this.url + 'get_only_jobdata', data, { headers });
  }
  getSchedulerSetupDate(data) {
    return this.http.post(this.url + 'get_schedular_setup_data', data, { headers });
  }
  viewJobDetails(data) {
    return this.http.post(this.url + 'get_job_data', data, { headers });
  }
  editJobDetails(data) {
    return this.http.post(this.url + 'edit_job', data, { headers });
  }
  getEmployee(data) {
    return this.http.post(this.url + 'get_employee_list', data, { headers });
  }
  deleteShift(data) {
    return this.http.post(this.url + 'delete_job', data, { headers });
  }
  copySchedule(data) {
    return this.http.post(this.url + 'copy_job', data, { headers });
  }
  totalShift(data){
    return this.http.post(this.url + 'total_shift', data, { headers });
  }
  getShiftSentList(data) {
    return this.http.post(this.url + 'candidate_list_company', data, { headers });
  }
  getShiftReqList(data) {
    return this.http.post(this.url + 'get_job_data', data, { headers });
  }
  getPastJobEmp(data){
    return this.http.post(this.url + 'employee_past_working', data, { headers });
  }
  getDateEmp(data) {
    return this.http.post(this.url + 'get_current_working_employee', data, { headers });
  }
  viewCompanyLocation(data) {
    return this.http.post(this.url + 'get_all_cmp_address', data, { headers });
  }
  addLocation(data) {
    return this.http.post(this.url + 'add_cmp_address', data, { headers });
  }
  deleteAddress(data) {
    return this.http.post(this.url + 'delete_cmp_address', data, { headers });
  }
  changeEmpStatus(data) {
    return this.http.post(this.url + 'change_emp_status', data, { headers });
  }
  duplicateJob(data){
    return this.http.post(this.url + 'duplicate_job', data, { headers });
  }
  listView(data){
    return this.http.post(this.url + 'list_view', data, { headers })
  }
  dragDropJob(data){
    return this.http.post(this.url + 'drop_shift', data, { headers });
  }
  jobRequest(data){
    return this.http.post(this.url + 'job_apply_company', data, { headers });
  }
  recruiterList(data){
    return this.http.post(this.url + 'get_recruiter_list', data, { headers });
  }
  unassignShift(data){
    return this.http.post(this.url + 'unpublish', data, { headers });
  }
  jobSummary(data){
    return this.http.post(this.url + 'counting_wages', data, { headers });
  }
  getTemplate(data){
    return this.http.post(this.url + 'get_template', data, { headers })
  }
  saveTemplate(data){
    return this.http.post(this.url + 'save_template', data, { headers })
  }
  editTemplate(data){
    return this.http.post(this.url + 'edit_template', data, { headers })
  }
  deleteTemplate(data){
    return this.http.post(this.url + 'delete_template', data, { headers })
  }
  autoRejectAll(data){
    return this.http.post(this.url + 'auto_reject_all', data, { headers })
  }
  getEmpDetail(data){
    return this.http.post(this.url + 'all_empc_data', data, { headers })
  }
  getCounting(data){
    return this.http.post(this.url + 'countingall_thing', data, { headers })
  }
  getQuestionList(data){
    return this.http.post(this.url + 'get_userwise_job_question_data', data, { headers })
  }
  getCountingAll(data){
    return this.http.post(this.url + 'countingall_thing', data, { headers });
  }
  getUserDetail(data){
    return this.http.post(this.url + 'all_user_listing', data, { headers })
  }
  getShiftActivity(data){
    return this.http.post(this.url + 'shift_activity', data, { headers })
  }
  
  getJobCounting(data){
    return this.http.post(this.url + 'weekly_count_all', data, { headers })
  }

}